module.exports = __webpack_public_path__ + "img/crown.7fddf60c.svg";